import {ReactNode} from "react";
import {AmazonStorageProvider} from "./amazon/AmazonStorageProvider";
import {Readable} from "stream";
import {FileItem} from "./FileItem";


export interface StorageProvider {
    name: string
    icon: ReactNode
    settingComponent: (props: StorageProviderSettingsProps) => ReactNode
    settings: StorageProviderSettings | undefined
    baseUrl: () => string
    upload: (file: Body, path: string, onProgress: (progress: number) => void) => Promise<string>
    delete: (fileName: string) => Promise<string>
    list: (path: string) => Promise<FileItem[]>
}

export interface StorageProviderSettings {
    id?: number,
    name: string,
    enabled: boolean,
    settings: any
}

export interface StorageProviderSettingsProps {
    settings: StorageProviderSettings,
    onChange: (settings: StorageProviderSettings) => void
}

export const providers: StorageProvider[] = [
    new AmazonStorageProvider()
]

export const getStorageProvider = (settings: StorageProviderSettings): StorageProvider | undefined => {
    const provider = providers.find(p => p.name === settings?.name)
    if (provider) provider.settings = settings
    return provider
}

export type Body = Buffer|Uint8Array|Blob|string|Readable;